/**
 * AI Assistant Button Component
 * Floating action button to open the AI assistant chat panel.
 */

import { SentraMark } from '@/components/brand/SentraMark';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface AIAssistantButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

export function AIAssistantButton({ onClick, isOpen }: AIAssistantButtonProps) {
  if (isOpen) return null;
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={onClick}
            className={cn(
              "fixed bottom-6 right-6 z-50",
              "h-12 w-12 rounded-full shadow-lg",
              "bg-primary hover:bg-primary/90",
              "transition-colors duration-200",
              "group"
            )}
          >
            <SentraMark size={22} color="#ffffff" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left" className="bg-foreground text-background">
          <p className="font-medium">Sentra AI Assistant</p>
          <p className="text-xs opacity-80">Ask me anything about your practice</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
